module.exports = __webpack_public_path__ + "static/media/confirmation.9b1e4a5c.svg";